import axios from 'axios';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const UnitAdd = () => {
  const navigate = useNavigate();
  const initialFormState = {
    unit_name: "",
    status: "",
  };

  const [UnitUser, setUnitUser] = useState(initialFormState);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setUnitUser({ ...UnitUser, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_unit",
        UnitUser
      );

     if (response.data.success === "1") {
  toast.success(response.data.message || "Unit added successfully!");
  navigate("/unit-list");
} else {
  toast.error(response.data.message || "Failed to add data");
}

    } catch (error) {
      console.error("API Error:", error.response || error.message);
      toast.error("Something went wrong!");
    }
  };


  return (
     <div className="page-content">
      <div className="container-fluid">
        {/* Page Header */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="fw-semibold mb-0">Product Unit Add</h4>
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="#">Master</a></li>
                <li className="breadcrumb-item active">Product Unit Add</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="card">
          <div className="card-header">
            <h5 className="mb-0">Add Product Unit</h5>
          </div>
          <form onSubmit={submitForm}>
          <div className="card-body row">
            <div className="col-md-6 mb-3">
              <label className="form-label text-dark">Unit Name</label>
              <input
                type="text"
                id='unit_name'
                name='unit_name'
                className="form-control"
                value={UnitUser.unit_name}
                onChange={handleInput}
                placeholder="Enter unit (e.g. Piece, Kg, Litre)"
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-dark">Status</label>
              <select
                className="form-control"
                id='status'
                name='status'
                value={UnitUser.status}
                onChange={handleInput}
              >
                <option value="">Select Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <div className="col-12">
              <button className="btn btn-primary" type='submit'>
                Add Unit
              </button>
            </div>
          </div>
          </form>
        </div>
        </div>
    </div>
  )
}

export default UnitAdd
